import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Sticky from 'react-sticky-el';
import { connect } from 'react-redux';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import { Link, browserHistory } from 'react-router';

import classes from './ActivityTable.scss';
import widthClasses from '../ActivityTableDetail/ColumnWidths.scss';
import ActivityTableDetail from '../ActivityTableDetail/ActivityTableDetail';
import { filterIt } from '../../helpers/filterIt';
import { setActivityForm, deleteActivity } from '../../store/modules/activity';
import ContextMenu from './ContextMenu';
import SimplDatepicker from '../SimplDatepicker/SimplDatepicker';
import moment from 'moment';
import BigCalendar from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import CompanyPicker from '../CompanyPicker/CompanyPicker';
import ProjectPicker from '../ProjectPicker/ProjectPicker';
import ServiceKeyPicker from '../ServiceKeyPicker/ServiceKeyPicker';
import Toolbar from './Toolbar';

const mapActionCreators = {
  setActivityForm,
  deleteActivity,
};

const mapStateToProps = state => ({
  companyCount: Object.keys(state.company.companies).length,
  birthday_staff: _.filter(
    _.pick(state.staff.staffs, state.staff.birthdays.all),
    ['deleted_at', null],
  ),
  birthday_persons: _.filter(
    _.pick(state.person.persons, state.person.birthdays.all),
    ['deleted_at', null],
  ),
  simplAccount: state.login.simplAccount,
});

const filter = {
  company: null,
  project: null,
  responsible: null,
  serviceType: null,
  from: moment().subtract(6, 'months'),
  until: moment().add(1, 'months'),
  setOn: moment(),
};

export class ActivityTable extends React.Component {
  constructor(props) {
    super(props);

    let storedFilters = {};
    const storageKey = `activityTableFilter_${
      props.simplAccount.length ? props.simplAccount : window.simplAccount
    }`;

    if (localStorage.getItem(storageKey) !== null) {
      storedFilters = JSON.parse(localStorage.getItem(storageKey));
      storedFilters.from = moment(storedFilters.from);
      storedFilters.until = moment(storedFilters.until);

      if (
        typeof storedFilters.setOn === 'undefined' ||
        !moment(storedFilters.setOn).isSame(new Date(), 'day')
      ) {
        // date filters were not set today, lets reset them to avoid confusion
        storedFilters.setOn = moment();
        storedFilters.from = filter.from;
        storedFilters.until = filter.until;
      }
    }

    const rememberedFilter = Object.assign({}, filter, storedFilters);

    this.state = {
      filter: rememberedFilter,
      order: 'start_time',
      orderDirection: false,
      isScrolling: false,
      openEvent: null,
      menuList: null,
      expanded: false,
    };
    this.scrollTimer = null;
    this.rightClickTimer = moment();

    moment.locale('de');
    BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));
  }

  componentDidMount() {
    this.scrollingContainer = document.querySelector('#scroller');
    if (this.scrollingContainer) {
      // https://stackoverflow.com/questions/38114715/how-to-reveal-a-react-component-on-scroll
      this.scrollingContainer.addEventListener('scroll', this.checkIfScrolling);
    }

    this.refresh = setTimeout(() => {
      this.forceUpdate();
    }, 1000);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
      return true;
    }

    if (
      JSON.stringify(
        _.omit(nextProps, ['setActivityForm', 'deleteActivity']),
      ) !==
      JSON.stringify(_.omit(this.props, ['setActivityForm', 'deleteActivity']))
    ) {
      return true;
    }

    return false;
  }

  componentWillUnmount() {
    if (this.scrollTimer !== null) {
      clearTimeout(this.scrollTimer);
    }

    if (this.refresh !== null) {
      clearTimeout(this.refresh);
    }

    this.scrollingContainer.removeEventListener(
      'scroll',
      this.checkIfScrolling,
    );
  }

  updateFilter = newCriteria => {
    const filter = Object.assign({}, this.state.filter, newCriteria);
    const storageKey = `activityTableFilter_${
      this.props.simplAccount.length
        ? this.props.simplAccount
        : window.simplAccount
    }`;

    localStorage.setItem(storageKey, JSON.stringify(filter));

    this.setState({ filter });
  };

  checkIfScrolling = e => {
    if (this.state.isScrolling === false) {
      this.setState({ isScrolling: true, openEvent: null });
    }

    if (this.scrollTimer !== null) {
      clearTimeout(this.scrollTimer);
    }
    this.scrollTimer = setTimeout(() => {
      // // console.log('scrolled');
      this.setState({ isScrolling: false });
    }, 150);
  };

  openContextMenu = (e, items) => {
    e.preventDefault();

    // console.log('opening!');

    const now = moment();
    if (now.diff(this.rightClickTimer) > 100) {
      this.rightClickTimer = now;

      this.setState({
        openEvent: {
          absX: e.clientX,
          absY: e.clientY,
        },
        menuList: items,
      });
    }
  };

  order = column => {
    if (column === this.state.order) {
      // column was already set, reverse order
      this.setState({ orderDirection: !this.state.orderDirection });
    } else {
      // column is different, lets order it
      this.setState({ order: column });
    }
  };

  filterActivity = activity => {
    let shouldReturn = true;

    if (this.state.filter.company !== null) {
      if (
        activity.company_id !== this.state.filter.company &&
        activity.companies.indexOf(this.state.filter.company) === -1
      ) {
        shouldReturn = false;
      }
    }

    if (this.state.filter.project !== null) {
      if (activity.project_id !== this.state.filter.project) {
        shouldReturn = false;
      }
    }

    if (this.state.filter.serviceType !== null) {
      if (activity.service_type_id !== this.state.filter.serviceType) {
        shouldReturn = false;
      }
    }

    return shouldReturn ? activity : null;
  };

  getActivities = () => {
    const activitiesAsArray = [];
    let filteredActivities = [];

    // iterate through each activity
    this.props.activities.forEach(activity => {
      // check if it should get displayed at all
      if (typeof activity.id !== 'undefined' && activity.deleted_at === null) {
        // total++;

        const responsibleStaff = _.find(this.props.staffs, [
          'id',
          activity.responsible_user,
        ]);

        // if there is a responsible user defined, get it.
        const responsible = responsibleStaff ? responsibleStaff.name : null;

        // tasks START

        // get the total amount of completed tasks
        const tasksCompleted = activity.tasks_completed
          ? activity.tasks_completed
          : 0;

        // get the total amount of tasks overall
        let totalTasks = 0;
        _.forOwn(activity.tasks, task => {
          if (
            typeof task.deleted_at === 'undefined' ||
            task.deleted_at === null
          ) {
            totalTasks++;
          }
        });

        const tasksRatio = tasksCompleted / totalTasks;
        // tasks END

        const filtered = this.filterActivity(activity);

        if (filtered !== null) {
          activitiesAsArray.push({
            ...activity,
            responsible,
            tasksRatio,
          });
        }
      }

      // filter with text in search input
      if (this.props.filter.length) {
        filteredActivities = filterIt(
          activitiesAsArray,
          this.props.filter,
          [],
          ['extraInfo'],
        );
      } else {
        filteredActivities = activitiesAsArray;
      }
    });

    let filteredByDate = [];

    filteredActivities.forEach(activity => {
      const start = moment(activity.start_time);
      const end = moment(activity.end_time);

      if (
        start.isAfter(this.state.filter.from) &&
        end.isBefore(this.state.filter.until)
      ) {
        filteredByDate.push(activity);
      }
    });

    // debugger;

    if (filteredByDate.length > 0) {
      let orderedActivities = _.orderBy(
        filteredByDate,
        [
          column =>
            typeof column[this.state.order] === 'string'
              ? column[this.state.order].toLowerCase()
              : typeof column[this.state.order] !== 'undefined'
              ? column[this.state.order]
              : null,
        ],
        [this.state.orderDirection ? 'asc' : 'desc'],
      );

      return orderedActivities;
    } else {
      return [];
    }
  };

  stripText = html => {
    var tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  getActivitiesForExcel = () => {
    const activities = this.getActivities();

    const excelActivities = activities.map(activity => {
      return {
        Titel: activity.title,
        'Verknüpft mit': activity.linkedWith.name,
        Kommunikationsart: activity.extraInfo.communicationString,
        'Datum Start': activity.extraInfo.startDateFull,
        'Datum Ende': activity.extraInfo.endDateFull,
        'Uhrzeit Start': activity.extraInfo.startTime,
        'Uhrzeit Ende': activity.extraInfo.endTime,
        'Dauer in Minuten': activity.extraInfo.durationInMinutes,
        'Effektive Dauer': activity.extraInfo.minutesToCalculate,
        Kosten: parseFloat(activity.extraInfo.cost),
        Beschreibung: this.stripText(activity.notes),
      };
    });

    return excelActivities;
  };

  s2ab = s => {
    // eslint-disable-next-line no-undef
    const buf = new ArrayBuffer(s.length);
    // eslint-disable-next-line no-undef
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  exportActivities = () => {
    const data = this.getActivitiesForExcel();

    var ws = XLSX.utils.json_to_sheet(data);
    ws['!cols'] = [
      {
        // titel
        width: 32,
      },
      {
        // verknüpft
        width: 32,
      },
      {
        // kommunikationsart
        width: 32,
      },
      {
        // datum start
        width: 32,
      },
      {
        // datum ende
        width: 32,
      },
      {
        // zeit start
        width: 6,
      },
      {
        // zeit ende
        width: 6,
      },
      {
        // dauer
        width: 6,
      },
      {
        // effektive dauer
        width: 10,
      },
      {
        // kosten
        width: 10,
      },
      {
        // beschreibung
        width: 128,
      },
    ];

    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');

    /* generate XLSX file */
    const wbout = XLSX.write(wb, { type: 'binary', bookType: 'xlsx' });
    /* send to client */
    FileSaver.saveAs(
      new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      'Aktivitäten.xlsx',
    );
  };

  renderFilter = () => {
    return (
      <div className={`form ${classes.filterRow} JoyrideActivityFilter`}>
        <div className={`${classes.filter} ${classes.date}`}>
          <label>Von</label>
          <SimplDatepicker
            defaultValue={this.state.filter.from}
            onChange={(formattedDate, date) => {
              this.updateFilter({ from: date });
            }}
          />
        </div>
        <div className={`${classes.filter} ${classes.date}`}>
          <label>Bis</label>
          <SimplDatepicker
            defaultValue={this.state.filter.until}
            minDate={this.state.filter.from}
            onChange={(formattedDate, date) => {
              this.updateFilter({ until: date });
            }}
          />
        </div>
        <div className={`${classes.filter} ${classes.company}`}>
          <label>Unternehmen</label>
          <CompanyPicker
            name="company"
            default={this.state.filter.company}
            onChange={e => this.updateFilter({ company: e.target.value })}
          />
        </div>
        <div className={`${classes.filter} ${classes.project}`}>
          <label>Projekt</label>
          <ProjectPicker
            name="project"
            default={this.state.filter.project}
            onChange={e => this.updateFilter({ project: e.target.value })}
          />
        </div>
        <div className={`${classes.filter} ${classes.serviceType}`}>
          <label>Leistungsart</label>
          <ServiceKeyPicker
            name="service_type_id"
            clearable
            default={this.state.filter.serviceType}
            onChange={e => this.updateFilter({ serviceType: e.target.value })}
          />
        </div>
        <div
          className={`${classes.filter} ${classes.export} hidden-phone`}
          onClick={() => {
            this.exportActivities();
          }}
        >
          <label>Excel Export</label>
          <button>Download</button>
        </div>
      </div>
    );
  };

  renderHeader = () => {
    if (this.props.activities.length === 0) {
      return <div />;
    }

    return (
      <div className={`${classes.headerWrapper}`}>
        <div className={`row ${classes.headerRow}`}>
          <div
            className={`
                  ${classes.cell}
                  ${classes.titleCell}
                  ${widthClasses.title}
                  ${this.state.order === 'title' ? classes.sorted : null}
                  ${this.state.orderDirection ? classes.asc : classes.desc}
                  `}
            onClick={() => {
              this.order('title');
            }}
          >
            Titel
          </div>
          <div
            className={`
                  ${classes.cell}
                  ${widthClasses.linked}
                  ${this.state.order === 'associated' ? classes.sorted : null}
                  ${this.state.orderDirection ? classes.asc : classes.desc}
                  hidden-phone
                  `}
            onClick={() => {
              this.order('associated');
            }}
          >
            Verknüpft mit
          </div>
          <div
            className={`
                  ${classes.cell}
                  ${widthClasses.communication}
                  ${
                    this.state.order === 'communication_type'
                      ? classes.sorted
                      : null
                  }
                  ${this.state.orderDirection ? classes.asc : classes.desc}
                  hidden-phone
                  `}
            onClick={() => {
              this.order('communication_type');
            }}
          >
            Kommunikation
          </div>
          <div
            className={`${classes.cell}
                  ${widthClasses.date}
                  ${this.state.order === 'start_time' ? classes.sorted : null}
                  ${this.state.orderDirection ? classes.asc : classes.desc}
                  hidden-phone
                  `}
            onClick={() => {
              this.order('start_time');
            }}
          >
            Zeitraum
          </div>
          <div
            className={`
                  ${classes.cell}
                  ${classes.dateCell}
                  ${widthClasses.pie}
                  ${this.state.order === 'tasksRatio' ? classes.sorted : null}
                  ${this.state.orderDirection ? classes.asc : classes.desc}
                  hidden-phone
                  `}
            style={{ width: 75, maxWidth: 75 }}
            onClick={() => {
              this.order('tasksRatio');
            }}
          >
            Status
          </div>
          <div
            className={`col-xs-1
                ${classes.cell}
                ${classes.responsible}
                ${widthClasses.users}
                ${this.state.order === 'responsible' ? classes.sorted : null}
                ${this.state.orderDirection ? classes.asc : classes.desc}
                hidden-phone
                `}
            onClick={() => {
              this.order('responsible');
            }}
          >
            Zuständiger
          </div>
        </div>
      </div>
    );
  };

  renderAsTableRows(activities) {
    return activities.map(activity => {
      const responsibleStaff = _.find(this.props.staffs, [
        'id',
        activity.responsible_user,
      ]);

      return (
        <ActivityTableDetail
          activity={activity}
          responsibleUser={responsibleStaff}
          mode={this.props.mode}
          key={`activitytable_${activity.id}`}
          compact={this.props.compact}
          setActivityForm={this.props.setActivityForm}
          deleteActivity={this.props.deleteActivity}
          openContextMenu={this.openContextMenu}
          closeContextMenu={() =>
            this.setState({
              openEvent: false,
            })
          }
        />
      );
    });
  }

  renderAsTable(orderedActivities) {
    let total = orderedActivities.length;
    const max = 25;
    let activities = [];
    let moreButton = <div />;

    if (orderedActivities.length > max) {
      let buttonText = `Weitere Aktivitäten laden (Zeige ${max} von ${total}).`;
      if (this.state.expanded) {
        buttonText = 'Weniger Aktivitäten anzeigen';
      } else {
        orderedActivities = orderedActivities.slice(0, max);
      }
      moreButton = (
        <div
          className={classes.moreButton}
          onClick={() => {
            this.setState({
              expanded: !this.state.expanded,
            });
          }}
        >
          {buttonText}
        </div>
      );
    }

    if (orderedActivities.length > 0) {
      activities = this.renderAsTableRows(orderedActivities);
    }

    if (activities.length === 0) {
      activities = (
        <div>
          <p className="text-center">
            <small>Keine Aktivitäten eingetragen.</small>
          </p>
        </div>
      );
    }
    return (
      <div className={classes.activityTable}>
        {this.renderFilter()}
        <Sticky scrollElement="#scroller">{this.renderHeader()}</Sticky>
        {activities}
        <ContextMenu
          menuList={this.state.menuList}
          openEvent={this.state.openEvent}
          onClose={() =>
            this.setState({
              openEvent: null,
            })
          }
        />
        {moreButton}
      </div>
    );
  }

  renderEventAgenda({ event }) {
    return (
      <span>
        <Link to={event.url}>{event.title}</Link>
        <HTMLEllipsis
          unsafeHTML={event.desc}
          maxLine="3"
          ellipsis="..."
          basedOn="letters"
          className={classes.notes}
        />
      </span>
    );
  }

  renderAsCalendar(activities) {
    const myEventsList = activities.map(activity => ({
      title: activity.title,
      start: activity.extraInfo.startDateObject,
      end: activity.extraInfo.endDateObject,
      url: `/activity/${activity.id}`,
      desc: activity.notes,
    }));

    this.props.birthday_persons.forEach(birthday => {
      if (typeof birthday.meta.date_of_birth !== 'undefined') {
        {
          myEventsList.push({
            title: `🎂 ${birthday.name}`,
            start: birthday.meta.date_of_birth.birthdayAsDate,
            end: birthday.meta.date_of_birth.birthdayEndAsDate,
            url: `/person/${birthday.id}`,
            allDay: true,
            desc: '',
            type: 'birthday',
          });
        }
      }
    });

    this.props.birthday_staff.forEach(birthday => {
      if (typeof birthday.meta.date_of_birth !== 'undefined') {
        {
          myEventsList.push({
            title: `🎂 ${birthday.name}`,
            start: birthday.meta.date_of_birth.birthdayAsDate,
            end: birthday.meta.date_of_birth.birthdayEndAsDate,
            url: `/person/${birthday.id}`,
            allDay: true,
            desc: '',
            type: 'birthday',
          });
        }
      }
    });

    const formats = {
      dateFormat: 'DD',

      dayFormat: (date, culture, localizer) =>
        localizer.format(date, 'dd, DD.MM.', culture),

      dayRangeHeaderFormat: ({ start, end }, culture, local) =>
        local.format(start, 'DD.MM.YYYY', culture) +
        ' — ' +
        local.format(end, 'DD.MM.YYYY', culture),
    };

    const min = moment()
      .hour('06')
      .minute('00')
      .toDate();
    const max = moment()
      .hour('20')
      .minute('00')
      .toDate();
    const startDate = moment().toDate();

    const messages = {
      allDay: 'ganztägig',
      previous: 'Zurück',
      next: 'Weiter',
      today: 'Heute',
      month: 'Monat',
      week: 'Woche',
      day: 'Tag',
      agenda: 'Agenda',
      date: 'Datum',
      time: 'Zeit',
      event: 'Aktivität',
      showMore: total => `+${total} weitere`,
    };

    return (
      <div>
        {this.renderFilter()}
        <BigCalendar
          events={myEventsList}
          views={['month', 'week', 'agenda']}
          step={30}
          popup
          selectable
          defaultDate={startDate}
          min={min}
          max={max}
          formats={formats}
          messages={messages}
          defaultView={localStorage.getItem('activityCalendarView') || 'month'}
          onView={view => localStorage.setItem('activityCalendarView', view)}
          onSelectEvent={event => browserHistory.push(event.url)}
          onSelectSlot={slotInfo => {
            const start = moment(slotInfo.start);
            const end = moment(slotInfo.end);

            const dateFormat = 'YYYY-MM-DD';
            const timeFormat = 'HH:mm';

            this.props.setActivityForm(null, {
              start_time: start.format(dateFormat),
              start_time_date_submit: start.format(dateFormat),
              start_time_time_submit: start.format(timeFormat),
              end_time: end.format(dateFormat),
              end_time_date_submit: end.format(dateFormat),
              end_time_time_submit: end.format(timeFormat),
              end_date_manual: true,
            });
          }}
          components={{
            agenda: {
              event: this.renderEventAgenda,
            },
            toolbar: Toolbar,
          }}
          eventPropGetter={(event, start, end, isSelected) => {
            let classNames = [];

            if (event.type === 'birthday') {
              classNames.push('calendar-event-birthday');
            }

            return { className: classNames.join(' '), style: {} };
          }}
        />
      </div>
    );
  }

  render() {
    let activities = this.getActivities();

    if (this.props.mode === 'calendar') {
      return this.renderAsCalendar(activities);
    } else {
      return this.renderAsTable(activities);
    }
  }
}

ActivityTable.propTypes = {
  activities: PropTypes.array,
  staffs: PropTypes.array,
  birthday_persons: PropTypes.array,
  birthday_staff: PropTypes.array,
  mode: PropTypes.string.isRequired,
  filter: PropTypes.string.isRequired,
  simplAccount: PropTypes.string,
  compact: PropTypes.bool,
  companyCount: PropTypes.number,
  setActivityForm: PropTypes.func.isRequired,
  deleteActivity: PropTypes.func.isRequired, // fetching: PropTypes.bool, // staffFetching: PropTypes.bool
};

ActivityTable.defaultProps = {
  // fetching: false,
  staffFetching: false,
  birthday_persons: [],
  birthday_staff: [],
  simplAccount: '',
};
export default connect(mapStateToProps, mapActionCreators)(ActivityTable);



// WEBPACK FOOTER //
// ./src/components/ActivityTable/ActivityTable.js